<div class="features-container" *ngIf="featuresForRoles.length > 0">
  <div class="feature-item" *ngFor="let featureCode of featuresForRoles">
    <label class="checkbox-container">
      <input
        type="checkbox"
        [checked]="checkedMap.get(featureCode)"
        (change)="onChange(featureCode)">
      <span class="checkmark"></span>
      <span class="feature-text">
        {{ 'superadministration.editUser.features.featuresList.' + featureCode | translate }}
      </span>
    </label>
  </div>
</div>
